import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { NAVIGATION_CHANNEL, OPERATIONAL_EVENT_TYPE } from '../utils/analytics';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { errorToReason } from '../utils/error-to-reason';
import { retryOnException } from '../utils/retry-operation';
import { withExperienceTracker } from '../utils/experience-tracker';
var DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
export var Status = /*#__PURE__*/function (Status) {
  Status["LOADING"] = "loading";
  Status["COMPLETE"] = "complete";
  Status["ERROR"] = "error";
  return Status;
}({});
export var createResultComplete = function createResultComplete(data) {
  return {
    status: Status.COMPLETE,
    data: data
  };
};
export var isComplete = function isComplete(result) {
  return result.status === Status.COMPLETE;
};
export var isError = function isError(result) {
  return result.status === Status.ERROR;
};
export var isLoading = function isLoading(result) {
  return result.status === Status.LOADING;
};
export var hasLoaded = function hasLoaded(result) {
  return result.status !== Status.LOADING;
};
export default function (name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
  var getInitialState = function getInitialState(props) {
    if (mapPropsToInitialValue) {
      var initialValue = mapPropsToInitialValue(props);
      if (initialValue !== undefined) {
        return {
          status: Status.COMPLETE,
          data: initialValue
        };
      }
    }
    return {
      status: Status.LOADING,
      data: null
    };
  };
  var DataProvider = /*#__PURE__*/function (_React$Component) {
    function DataProvider() {
      var _this;
      _classCallCheck(this, DataProvider);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, DataProvider, [].concat(args));
      _defineProperty(_this, "acceptResults", true);
      _defineProperty(_this, "state", getInitialState(_this.props.params));
      _defineProperty(_this, "fireOperationalEvent", function (payload) {
        if (_this.props.createAnalyticsEvent) {
          _this.props.createAnalyticsEvent(_objectSpread(_objectSpread({
            eventType: OPERATIONAL_EVENT_TYPE,
            actionSubject: DATA_PROVIDER_SUBJECT
          }, payload), {}, {
            attributes: _objectSpread(_objectSpread({}, payload.attributes), {}, {
              outdated: !_this.acceptResults
            })
          })).fire(NAVIGATION_CHANNEL);
        }
      });
      return _this;
    }
    _inherits(DataProvider, _React$Component);
    return _createClass(DataProvider, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        /**
         * Promise resolved after component is unmounted to be ignored
         */
        this.acceptResults = false;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.experienceTracker.markStart(experienceMark);
        this.fetchData();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) {
          this.fetchData();
        }
      }
    }, {
      key: "fetchData",
      value: function fetchData() {
        var _this2 = this;
        retryOnException(function () {
          return mapPropsToPromise(_this2.props.params);
        }, {
          intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
          shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
          onRetry: function onRetry(previousException, retryCount) {
            _this2.onRetry(previousException, retryCount);
          }
        }).then(function (result) {
          _this2.onResult(result);
        }).catch(function (error) {
          _this2.onError(error);
        });
      }
    }, {
      key: "onResult",
      value: function onResult(value) {
        if (this.acceptResults) {
          this.setState({
            data: value,
            status: Status.COMPLETE
          });
        }
        this.props.experienceTracker.markEnd(experienceMark);
        this.fireOperationalEvent({
          action: 'receivedResult',
          actionSubjectId: name,
          attributes: {
            provider: name
          }
        });
      }
    }, {
      key: "onRetry",
      value: function onRetry(error, retryCount) {
        this.fireOperationalEvent({
          action: 'retried',
          actionSubjectId: name,
          attributes: {
            provider: name,
            reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : errorToReason(error),
            retryCount: retryCount
          }
        });
      }
    }, {
      key: "onError",
      value: function onError(error) {
        /**
         * Do not transition from "complete" state to "error"
         */
        if (this.acceptResults && !isComplete(this.state)) {
          this.setState({
            error: error,
            status: Status.ERROR,
            data: null
          });
        }
        this.fireOperationalEvent({
          action: 'failed',
          actionSubjectId: name,
          attributes: {
            provider: name,
            reason: errorToReason(error)
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children(this.state);
      }
    }]);
  }(React.Component); // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
  // This results in a cache miss due to a key mismatch.
  // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
  // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
  _defineProperty(DataProvider, "displayName", "DataProvider(".concat(name, ")"));
  var InnerComponent = withAnalyticsEvents()(withExperienceTracker(DataProvider));
  var OuterComponent = function OuterComponent(_ref) {
    var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(InnerComponent, {
      params: params
    }, children);
  };
  return OuterComponent;
}